import { Link, useNavigate } from "react-router-dom";
import ArcButton, { ButtonColor, ButtonIcon, ButtonType } from "app/components/arc/ArcButton";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div id="wrap">
      <header id="header">
        <div className="hdt-link">
          <div className="ht-tit">
            <Link to="/" title="홈 화면으로 이동">
              <h1 className="logo">
                <span className="hid">e.CLOUD</span>
              </h1>
            </Link>
          </div>
        </div>
      </header>

      <div id="container">
        <div className="error-wrap">
          <div>
            <img src={require('portal/assets/img/sub/not-found.png')} alt="error image"/>
            <p className="txt1">페이지를 찾을 수 없습니다.</p>
            <p className="txt2">페이지의 URL을 확인해주세요.</p>
            <ArcButton
              type={ButtonType.custom}
              color={ButtonColor.btn1}
              hasIcon={true}
              icon={ButtonIcon.home}
              text="홈으로"
              onClick={() => navigate('/', {replace: true})}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
